<template>
  <v-overlay>
    <v-progress-circular indeterminate size="64"></v-progress-circular>
  </v-overlay>
</template>

<script>
import OAuth from "./../oAuth2";
let sha256 = require("js-sha256");
let Url = require("url");
export default {
  name: "Login",
  methods: {
    redirect() {
      this.$root.$emit("init");
      if (localStorage.urlBeforeLogin) {
        window.location = localStorage.urlBeforeLogin;
        localStorage.removeItem("urlBeforeLogin");
      } else {
        this.$router.push("/");
      }
    },
    async uri() {
      let state = this.generateRandomString();
      localStorage.setItem("pkce_state", state);

      let code_verifier = this.generateRandomString();
      localStorage.setItem("pkce_code_verifier", code_verifier);

      let code_challenge = await this.pkceChallengeFromVerifier(code_verifier);

      let location = OAuth.code.getUri({
        query: {
          code_challenge,
          state,
          code_challenge_method: "S256"
        }
      });
      window.location = location;
    },
    code() {
      if (localStorage.pkce_state !== this.$route.query.state) {
        return;
      }
      let code_verifier = localStorage.pkce_code_verifier;
      OAuth.code
        .getToken(
          {
            hash: this.$route.hash,
            query: this.$route.query,
            pathname: Url.parse(window.location.href).pathname
          },
          {
            body: { code_verifier }
          }
        )
        .then(res => {
          this.$store.dispatch("sessionStore/setToken", {
            token: res.accessToken
          });
          this.redirect();
        })
        .catch(res => {
          this.$store.dispatch("notificationStore/createNotification", {
            text: `${res}`,
            type: "error",
            value: true
          });
        });
    },

    generateRandomString() {
      let array = new Uint32Array(28);
      let crypto = window.crypto || window.msCrypto;
      crypto.getRandomValues(array);
      return Array.from(array, dec => ("0" + dec.toString(16)).substr(-2)).join(
        ""
      );
    },
    async pkceChallengeFromVerifier(v) {
      let hash = sha256.create();
      hash.update(v);
      return this.base64urlencode(hash.array());
    },
    async base64urlencode(str) {
      return btoa(String.fromCharCode.apply(null, new Uint8Array(str)))
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/, "");
    }
  },
  mounted() {
    if (this.$route.query.code) {
      this.code();
    } else {
      if (!this.$store.getters["sessionStore/getToken"]) {
        this.uri();
      } else {
        this.redirect();
      }
    }
  }
};
</script>

<style scoped></style>
